import React from 'react'

import { Snackbar, Slide } from '@material-ui/core'

import './index.scss'

function SlideTransition(props) {
    return <Slide {...props} direction='down' />
}

class DisconnectSnackbar extends React.Component {
    constructor(props) {
        super(props)

        this.state = {}
        this.closeSnackbar = this.closeSnackbar.bind(this)
    }

    closeSnackbar() {
        this.setState({ disconnected: false })
    }

    render() {
        const vertical = 'top'
        const horizontal = 'right'

        const { isConnected } = this.props

        return (
            <div className='DisconnectSnackbar'>
                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    key={`${vertical},${horizontal}`}
                    open={!isConnected}
                    onClose={this.closeSnackbar}
                    TransitionComponent={SlideTransition}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                        classes: {
                            root: 'snackbar-root',
                            message: 'snackbar-message',
                        },
                    }}
                    autoHideDuration={2000}
                    message={
                        <div>
                            <p className='snackbar-message__title'>
                                Connecting...
                            </p>
                        </div>
                    }
                />
            </div>
        )
    }
}

export default DisconnectSnackbar
